/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { MessagesManager } from '../PRIVATE_Message';
import { Item } from '../utils/UNSAFE_dataProvider';
import { ComponentMessage, ComponentMessageItem } from './ComponentMessage';
import { componentMessageContainerBase } from './themes/ComponentMessageStyles.css';

/**
 * Converts the messages data into Item
 *
 * @param messages The messages data passed down as prop
 * @returns The messages data as Item
 */
function generateMessagesData(messages: ComponentMessageItem[]) {
  return messages.map<Item<number, ComponentMessageItem>>((message, index) => {
    return {
      key: index,
      data: {
        closeAffordance: 'off',
        severity: message.severity || 'error',
        detail: message.detail
      }
    };
  });
}

/**
 * Props for the ComponentMessaging component
 */
type Props = {
  /**
   * The label of the field which is showing this error
   */
  fieldLabel?: string;

  /**
   * Data for the messages. This data is used for rendering each message.
   */
  messages?: ComponentMessageItem[];
};

export function ComponentMessageContainer({ fieldLabel, messages = [] }: Props) {
  return (
    <div class={componentMessageContainerBase}>
      <MessagesManager data={generateMessagesData(messages)}>
        {({ item }) => (
          <ComponentMessage
            key={item.key}
            detail={item.data.detail}
            fieldLabel={fieldLabel}
            severity={item.data.severity}
          />
        )}
      </MessagesManager>
    </div>
  );
}
